import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Calendar } from 'src/app/models/centrex/calendar';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class CalendarService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getCalendars(): Observable<Calendar[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Calendar[]>(`${this.baseUrl}/api/calendars`, httpOptions);
    }

    getCalendar(calendarId: string): Observable<Calendar> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Calendar>(`${this.baseUrl}/api/calendars/${calendarId}`, httpOptions);
    }

    addCalendar(calendar: Calendar, globalNotification = true): Observable<Calendar> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Calendar>(`${this.baseUrl}/api/calendars`, calendar, httpOptions);
    }

    updateCalendar(calendar: Calendar): Observable<Calendar> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Calendar>(`${this.baseUrl}/api/calendars/${calendar.id}`, calendar, httpOptions);
    }

    deleteCalendar(calendarId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Calendar>(`${this.baseUrl}/api/calendars/${calendarId}`, httpOptions);
    }
}
